export default "__VITE_ASSET__DlE2mNTu__"